import './index.styl';
import template from './index.jst';
import { PlayerPoolFiltres } from '../../index';
import Radio from 'backbone.radio';
import { User } from '../../../../models';
import { Model } from "backbone";

import _ from 'lodash';
import { isAuthorized } from "../../../../../../core/utils";

const
	CHANNEL_STATS = Radio.channel('stats'),
	CHANNEL_TRADE = Radio.channel('trade'),
	CHANNEL_COACH = Radio.channel('coach');

/**
 * @description View with filters for Trade Player Pool List
 */
export class TradePlayerPoolFilters extends PlayerPoolFiltres {
	get template() {
		return template;
	}

	get className() {
		return 'trade-pool-filters';
	}

	ui() {
		return {
			...super.ui(),
			btn_base_stats: '.js-btn-trade-pool-base',
			btn_coach_stats: '.js-btn-trade-pool-coach',
			order_by: '.js-order-by',
			table_header: '.trade-player-pool-table-head-container',
			coach_type: '#coach-stats-type'
		}
	}

	events() {
		return {
			...super.events(),
			'click @ui.btn_base_stats': 'onChangeToBaseStats',
			'click @ui.btn_coach_stats': 'onChangeToCoachStats',
			'click @ui.order_by': 'onChangeOrder',
			'change @ui.coach_type': 'onChangeCoachData',
		}
	}

	initialize() {
		this.model = new Model({
			filter: {},
			selected: {
				order_by: 'stats.avg_points'
			},
			is_visible_filters: false,
			stats_type: 'base',
			coach_stats_types: this.coach_stats_types,
			coach_stats_type: 'value_predictor',
			last_round_id: 1,
			actual_round_id: 1,
			next_round_id: 1,
			scheduled_round_id: 1,
			most_recent_round_id: 1,
			is_authorized: isAuthorized()
		});

		this.initListeners();
	}

	get coach_stats_types() {
		return [{
			name: 'Form',
			value: 'form',
			order_by: 'stats.last_3_avg',
		}, {
			name: 'Value Predictor',
			value: 'value_predictor',
			order_by: 'stats.last_3_avg',
		}, {
			name: 'Consistency',
			value: 'consistency',
			order_by: 'stats.consistency',
		}, {
			name: 'Opposition',
			value: 'opposition',
			order_by: 'stats.opp_avg_one_round_after_current',
		}, {
			name: 'Venues',
			value: 'venues',
			order_by: 'stats.venue_avg_one_round_after_current',
		}, {
			name: 'Coach choice',
			value: 'coach_choice',
			order_by: 'stats.selections',
		}];
	}

	initListeners() {
		super.initListeners();
		this.listenTo(CHANNEL_TRADE, 'data:changed', this.init);
		this.listenTo(CHANNEL_TRADE, 'filter:by:position', this.filterByPosition);


		this.listenTo(
			CHANNEL_TRADE,
			'trade:team:value:update',
			/**
			 * debounce is a hack, because this event calls twice
			 * Invoke `onTeamValueUpdate` when the event is fired,
			 * but not more than once every 50 milliseconds.
			 */
			_.debounce(
				this.onTeamValueUpdate,
				50,
				{ 'leading': true, 'trailing': false }
			)
		);
	}

	onTeamValueUpdate({ remaining_salary }){
		const
			by_price = this.getFilterByPriceOptions(remaining_salary),
			filter_by_price = this.correctFilterByPrice(by_price),
			selected = {
				...this.model.get('selected'),
				filter_by_price,
			};

		this.model.set({
			selected,
			filter: {
				...this.model.get('filter'),
				by_price,
			}
		});

		if (filter_by_price) {
			this.trigger('filter:players', selected);
		}
	}

	onChangeToBaseStats() {
		const selected = {
			...this.model.get('selected'),
			order_by: 'stats.avg_points'
		};

		this.model.set({
			stats_type: 'base',
			selected
		});

		CHANNEL_STATS.trigger('change:players:template', 'base');
		this.trigger('filter:players', selected);
	}

	onChangeToCoachStats() {
		if (!User.has_assistant_coach) {
			CHANNEL_COACH.trigger('show:popup');

			return this;
		}
		const selected = {
			...this.model.get('selected'),
			order_by: 'stats.avg_points',
		};
		this.model.set({ stats_type: 'coach', selected });
		this.onChangeCoachData();
	}

	onChangeOrder(event) {
		const
			filters = this.model.get('selected'),
			selected = {
				...filters,
				order_by: event.currentTarget.dataset.orderBy
			};

		if (_.eq(selected.order_by, filters.order_by)) {
			selected.is_asc_order = !filters.is_asc_order;
		}

		this.model.set({ selected });

		this.trigger('filter:players', selected);
	}

	onChangeCoachData() {
		const
			coach_stats_type = (
				this.ui.coach_type.val() || this.model.get('coach_stats_type')
			),
			selected = {
				...this.model.get('selected'),
				order_by: _.result(_.find(
					this.coach_stats_types,
					{ value: coach_stats_type }
				), 'order_by', 'stats.avg_points'),
				is_asc_order: false
			};

		this.model.set({
			coach_stats_type,
			selected
		});

		CHANNEL_STATS.trigger('change:players:template', coach_stats_type);
		this.trigger('filter:players', selected);
	}

	onDomRefresh() {
		this.ui.table_header.scrollLeft(this.model.get('scrollLeft') || 0);
	}

	scrollLeftHeader(scrollLeft) {
		this.ui.table_header.scrollLeft(scrollLeft);
		this.model.set({ scrollLeft }, { silent: true });
	}

	filterByPosition(position) {
		$(document).find('.js-player-pool-by-positions').val(position).trigger('change');
	}
}

export default TradePlayerPoolFilters;